import video from './VideoList.module.scss'
import Image from 'next/image'
export const VideoList = ({ title, description, image: { name: imgName, url: imgUrl }, image2: { name: imgName2, url2: imgUrl2 } }) => {
  return (
    <div style={{ marginTop: '1.9%', display: 'flex', flexDirection: 'row' }}>
      <div className={video.image_wrapper}>
        <div className={video.image_text}>
          <Image
            src={imgUrl}
            alt={imgName}
            className={video.logo}
            width={116}
            height={32}
          />
          <p className={video.textoimg}>{title}</p>
        </div>
        <Image
          src={imgUrl2}
          alt={imgName2}
          width={264}
          height={148}
        />
      </div>
      <div className={video.text_wrapper}>
        <p className={video.txtaladoimg}>{description}</p>
      </div>
    </div>
  )
}
